const {fr} = require("date-fns/locale");
const { registerLocale, setDefaultLocale } = require("react-datepicker");

registerLocale('fr', fr);
setDefaultLocale('fr');

module.exports = {
  "last_news_label": {
    "fr": "Actualités"
  },
  "search_placeholder": {
    "fr": "Keolis Touraine"
  },
  "api_token": "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJpYXQiOjE2MjI3MDA0NzQsImV4cCI6MTY1NDIzNjQ3NCwidXNlcm5hbWUiOiIzOSJ9.zwtl76to23UQCkU0YZ2_nXhraXHiTecT01Jm2jCqEi8J6DDWtuU7ZSKIsHcmLkeBq7vp5EDQZgnemlEV9hwp-lLZ6bsTeqju0PmZO2c0I3DxDAKtqr5xHMtDW1qwqXTo6rs0CiAyFpYNkIoWQOK2Um7B19Vf4x5wMHhA76FOLcRTX1KmiJtShv6jekXdGqzusQjxFBgEacZJcHrbA58i0l-s-uyPxNV6i9wm9NWwHiVcziZdeqspNs1gGEkJYpfyqFYsnmUf7T31gGtK0RtOyjvAoPCuWVCMdNi-jgHdbTkMNTJ6IM2flKhR0LcBk-4Vqr9rEJcA8rHOxIPmPffVVy0XBAoLE3Zw5u9jgpv4saONqCVubw1y6Ix9DKfa_gNTbYcrVD9ZGcQph882nNY5hBgAuHt7PuJgNhKGVHrxs2_hHs3KzxW2ZxlpbgB56MfvV85V8qTzHfckAOuV2HKzUGze2bdcaVrLVOJAgziZRymqpkSfSLmc0rCsiAPUb5JVr66GguTiZefoj4A-riya71-HaCovKaZOO6gFT_vJy84LC1qI1M7T64pb-CcPymQDsrH_SvOVFdZNhPzsbDkU8EaPw6J5csO4_OjlGpINOlYkdA5BWQUBgEFBXkZcIGMv9Zmcp-xTewP4j1RGRnY7YeeIoyNw-uv3HfWF6T5fzE0",
  "mapbox_token": "pk.eyJ1IjoibWltaXJvc2UyOSIsImEiOiJjbGV3cHhsaGgxMHV2NDNtazAxOGM0MXhrIn0.LieDdLfJevyJ6njBc9-vQg",
  "info_traffic_title": {
    "fr": "Toute l'info trafic"
  },
  "date_format": {
    "fr": "dd/MM/yyyy"
  },
  "fb_display": false,
  "side_blocks": {
    "fr": [
      "42042287"
    ]
  },
  "notifications_service_endpoint": "https://apim.keolis.com/KWP000/notification",
  "display_contact": true,
  "api_url": "https://api-v2.mobireport.fr",
  "twitter_display": false,
  "search_title": {
    "fr": "Recherche"
  },
  "serverless_sendmail_endpoint": "https://apim.keolis.com/dato/send/form",
  "notifications_service_import_file_endpoint": "https://apim.keolis.com/KWP000/file/import",
  "contact_label": {
    "fr": "Renseignements"
  },
  "info_traffic_slug": {
    "fr": "toutes-les-infos-trafic"
  },
  "news_redirect_label": {
    "fr": "Lire l'actualité"
  },
  "website_name": "Keolis Touraine",
  "time_format": {
    "fr": "HH:mm"
  },
  "info_traffic_detail_slug": {
    "fr": "Détail de l'info trafic"
  },
  "notifications_service_token": "1142321004f3407b98a95856f9820607",
  "search_button_label": {
    "fr": "Rechercher"
  },
  "serverless_sendmail_token": "1142321004f3407b98a95856f9820607",
  "contact_phone_number": {
    "fr": "02 47 44 00 00"
  },
  "primary_color": {
    "red": 0,
    "green": 95,
    "blue": 125,
    "alpha": 255
  },
  "alt_text": {
    "fr": "Renseignements : 02 47 44 00 00"
  },
  "info_traffic_content_title": {
    "fr": "L'information trafic"
  },
  "gradient_primary_color": {
    "red": 0,
    "green": 151,
    "blue": 198,
    "alpha": 255
  },
  "no_search_label": {
    "fr": "Veuillez saisir des termes et valider pour lancer la recherche"
  },
  "redirection_button_text": {
    "fr": "+ D'INFOS"
  },
  "search_icon_color": {
    "red": 255,
    "green": 255,
    "blue": 255,
    "alpha": 1
  },
  "search_in_progress_label": {
    "fr": "Recherche en cours..."
  },
  "search_no_results_label": {
    "fr": "Il n'y a aucun résultat pour cette recherche"
  },
  "gradient_button_color": {
    "red": 12,
    "green": 125,
    "blue": 123,
    "alpha": 255
  },
  "search_error_label": {
    "fr": "Une erreur s'est produite, veuillez réessayer dans quelques minutes"
  },
  "active_button_text_color": {
    "red": 255,
    "green": 255,
    "blue": 255,
    "alpha": 255
  },
  "search_token": "124c96bbe2b5011f8b9e9a785cfc84",
  "secondary_color": {
    "red": 255,
    "green": 255,
    "blue": 255,
    "alpha": 255
  },
  "subsidiary_logo": {
    "path": "/50145/1693475177-keolis_touraine_blanc.svg",
    "format": "svg",
    "size": 2208,
    "alt": "Logo Keolis Touraine",
    "title": "Keolis Touraine",
    "width": 416,
    "height": 161
  },
  "back_to_home_title": {
    "fr": "Keolis Touraine – revenir à la page d'accueil"
  },
  "language_selector_title": {
    "fr": "Changer la langue"
  },
  "piano_site_id": "639229",
  "google_tag_manager_id": "GTM-NB9G5VB",
  "google_analytics_key": "",
  "didomi_api_key": "2127e597-3d3f-4aa2-9727-c8126f86298c",
  "actistat_key": "",
  "loader": {
    "path": "/50145/1693496620-loader-bleu-utilisateur.gif",
    "format": "gif",
    "size": 830108,
    "alt": "Page en chargement, veuillez patientez s'il vous plaît",
    "title": "Page en chargement",
    "width": 1080,
    "height": 1080
  },
  "api_url_get_lines_endpoint": "/public/line",
  "api_url_user_registration_endpoint": "/public/customer",
  "scripts": [],
  "form_captcha_key": "6Lcd1DMjAAAAAEsHVSyCqBSA_c8IBpjJStjgY_pH",
  "updated_at": "2026-03-17T17:22:55.114+01:00",
  "created_at": "2020-12-29T15:46:21.809+01:00",
  "locale": "fr",
  "locales": [
    "fr"
  ],
  "siteUrl": "https://www.keolis-touraine.fr/",
  "readOnlyApi": "a0eaa7d0ff0f032c57fc1e32043199"
}